<template>
  <div v-if="!reloading">
    <b-modal v-model="downloading" hide-footer>
      Estamos preparando o download dos arquivos. Esse processo pode demorar um pouco.
      <!--<b-row>
        <b-col>
          <b-button class="mt-3 bg-success" block @click="showRemoveUploadModal = false">Cancelar</b-button>
        </b-col>
        <b-col>
          <b-button class="mt-3 bg-danger" block @click="removeUpload(uploadToRemove)">Excluir</b-button>
        </b-col>
      </b-row>-->
      <br/>
      <br/>
    </b-modal>
    <div class="content-wrapper m-t">
      <div class="list-wraper">
        <b-row id="main-row" v-if="allCarouselTemplates && !changingColor && loaded && !isMine && challenge" style="margin-top: 10px;">
          <b-col class="text-center">
            <div>
              <a href="#chooseMobileColors" @click.prevent="goToChallenge" class="btn btn-outline-warning btn-desafio" variant="primary">Voltar para o Desafio</a>
            </div>
          </b-col>
        </b-row>
        <b-row id="main-row" v-if="allCarouselTemplates && loaded && !isMine" style="margin-top: 10px;">
          <b-col class="text-center">
            <div>
              <a href="#chooseMobileColors" v-if="!customColorsCarousel" @click="enableColorChange" class="btn btn-success" style="color: white;" variant="success">Alterar cor dos cards do carrossel</a>
            </div>
          </b-col>
        </b-row>
        <b-row id="main-row" v-if="allCarouselTemplates && !changingColor && loaded && !isMine && me && !me.isExpired" style="margin-top: 10px;">
          <b-col class="text-center">
            <div>
              <a href="#chooseMobileColors" @click="saveAll" class="btn btn-primary" style="color: white;" variant="primary">Salvar em Meus Sleekers ({{creditsToDownloadAll}} créditos)</a>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="convertedInstructions">
          <b-col>
            <b-card>
              <b-card-body>
                <div>
                  <span>Instruções</span>
                  <br />
                  <div style="border-style: solid; border-color: #63c2de; padding: 10px;">
                    <span v-html="convertedInstructions"></span>
                  </div>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <!--<b-row id="main-row" v-if="allCarouselTemplates && !changingColor && loaded && !isMine && !isMobileScreen" style="margin-top: 10px;">
          <b-col class="text-center">
            <div>
              <a href="#chooseMobileColors" @click="downloadAll" class="btn btn-primary" style="color: white;" variant="primary">Baixar todos ({{creditsToDownloadAll}} créditos)</a>
            </div>
          </b-col>
        </b-row>-->
        <!--<b-row id="main-row" v-if="allCarouselTemplates && !changingColor && loaded && isMine && !isMobileScreen" style="margin-top: 10px;">
          <b-col class="text-center">
            <div>
              <a href="#chooseMobileColors" @click="downloadAll" class="btn btn-primary" style="color: white;" variant="primary">Baixar todos</a>
            </div>
          </b-col>
        </b-row>-->
        <br/>
        <p v-for="(line, index) in carouselLines" :key="index">{{line}}</p>
        <spinner id="loadingDiv" class="m-t" v-if="!loaded"></spinner>
        <b-row v-if="allCarouselTemplates && customColorsCarousel && loaded">
          <b-col class="text-center">
            <div>
              <a href="#chooseMobileColors" @click="disableColorChange" class="btn btn-primary" style="color: white;">Usar cor original</a>
            </div>
            <br/>
            <div>
              <a href="#chooseMobileColors" v-if="changingColor && !choosingAnotherColor" @click="choosingAnotherColor = true" class="btn btn-warning" style="color: white;">Escolher outra cor</a>
            </div>
            <br/>
            <div v-if="changingColor">
              <a href="#chooseMobileColors" v-if="!choosingAnotherColor" @click="colorChosen()" class="btn btn-success" style="color: white;">Confirmar Cor</a>
            </div>
            <br/>
          </b-col>
        </b-row>
        <b-row v-if="customColorsCarousel && changingColor && choosingAnotherColor" style="margin-bottom: 100px;">
          <b-col cols="12">
            <color-slider :customHeight="900" v-bind:colors="colors" v-bind:favoriteColors="favoriteColors" v-on:changeColor="changeColor" v-if="colors && colors.length && favoriteColors" v-bind:admin="false"/>
          </b-col>
          <b-col cols="12" class="text-center">
            <p>
            Escolha a cor para ver as artes 
            </p>
          </b-col>
        </b-row>
        <b-row v-if="allCarouselTemplates && allCarouselTemplates.length && loaded && (!changingColor || !choosingAnotherColor)">
          <b-col sm="3" xs="6" class="text-center" v-for="(templateInfo, index) in allCarouselTemplates" :key="index">
            <div v-if="templateInfo.carouselLine == selectedCarouselLine">
              <carousel-item v-on:finishedLoading="finishedLoadingAny" :ref="'carouselItem'" :originalTemplate="templateInfo" :customColorsTemplate="templateInfo.customColorsVersion" :customColorsCarousel="customColorsCarousel" :filters="filters" :changingColor="changingColor" v-on:expressEdition="expressEdition" v-on:updateCarousel="updateCarousel" v-on:finishedDownload="finishedDownload" :isMine="isMine"/>
            </div>
          </b-col>
          <div v-for="(carouselLineId, index) in carouselLinesList" :key="index" style="width: 100%; margin-bottom: 10px;">
            <b-col sm="3" xs="6" class="text-center" v-if="(carouselLineId != selectedCarouselLine) && carouselLines[carouselLineId] && carouselLines[carouselLineId].templates && carouselLines[carouselLineId].templates.length">
              <img :src="carouselLines[carouselLineId].templates[0].watermarkedNeutral" style="max-width: 200px;"/>
              <br/>
              <b-row class="text-center">
                <b-col>
                  <br/>
                  <b-button @click="seeVersion(carouselLineId)" variant="warning">Ver esta versão</b-button>
                </b-col>
              </b-row> 
            </b-col>
          </div>
          <b-col style="margin-top: 30px;" sm="12">
            <b-card>
            <subtitle-box v-bind:isStory="allCarouselTemplates[0].story" v-bind:subtitle="allCarouselTemplates[0].subtitle" />
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import VueImageModel from "./editor/ImageModel.vue";
import Dropzone from "./Dropzone";
import service from "../service";
import { isMobile } from "mobile-device-detect";
import Spinner from "./Spinner";
import Config from "../config";
import { constants } from "fs";
import { setTimeout } from "timers";
import { Chrome } from "vue-color";
import ColorSlider from './ColorSlider.vue';
import axios from "axios";
import SubtitleBox from "./SubtitleBox"
import CarouselItem from './CarouselItem.vue';

export default {
  name: "PreviewCarousel",
  components: {
    VueImageModel,
    dropzone: Dropzone,
    Spinner,
    ColorSlider,
    "chrome-picker": Chrome,
    SubtitleBox,
    CarouselItem
  },
  props: {
    json: undefined,
    creation: undefined,
    customSavingUrl: undefined,
    isMine: false
  },
  data() {
    return {
      showRemoveUploadModal: false,
      uploadToRemove: undefined,
      templateId: this.$route.params.id,
      template: undefined,
      userAddedUniques: "",
      psd: false,
      imgUrl: "",
      list: [],
      isMobileScreen: isMobile,
      loading: false,
      jsonCopy: undefined,
      jsonObject: undefined,
      test1: true,
      test2: false,
      advancedEdition: false,
      backgroundImage: "",
      loaded: false,
      loadingAttachment: false,
      actionList: undefined,
      showImportImage: false,
      enableSendToBackground: false,
      currentItem: null,
      showSave: false,
      showTextEdit: false,
      showTrash: false,
      selectedIndex: -1,
      loadingJson: false,
      temporaryText: "",
      selectedColor: "#ffffff",
      changingTextColor: false,
      changingTextFont: false,
      background: "transparent",
      fontList: [
        
      ],
      updatingTextProperties: false,
      story: false,
      preventLocking: false,
      reloading: false,
      forceStory: false,
      disableSaveButton: false,
      lastJson: [],
      baseImageLoaded: false,
      preventUndo: false,
      lineSize: 0.8,
      blockNewSleeker: false,
      choosingElement: false,
      choosingElementVersion: false,
      elements: [],
      selectedElement: undefined,
      customEditorSize: "",
      heightAndWidth: {},
      imgList: [],
      colors: [],
      me: {},
      filters: { hueValue: 0, saturationValue: 0, brightnessValue: 0},
      lastColor: undefined,
      colors: [],
      favoriteColors: [],
      lastHue: undefined,
      lastSaturation: undefined,
      lastBrightness: undefined,
      allCarouselTemplates: [],
      carouselLines: [],
      carouselLinesList: [],
      selectedCarouselLine: undefined,
      customColorsCarousel: false,
      shouldAllowColorChange: true,
      changingColor: false,
      creditsToDownloadAll: 0,
      selectedColorId: 0,
      shouldDownload: 0,
      downloading: false,
      alreadyUsedCredits: false,
      challenge: "",
      choosingAnotherColor: true,
    };
  },
  computed: {
    convertedInstructions: function() {
      if (this.allCarouselTemplates && this.allCarouselTemplates.length && this.allCarouselTemplates[0].instructions) {
        let instructions = this.allCarouselTemplates[0].instructions.replace(new RegExp("\n", 'g'), "<br/>");
        
        return instructions;
      }
      return false;
    },
    whitelabelName() {
      return localStorage.whitelabelName;
    },
    isAdmin: function() {
      return localStorage.admin;
    },
    initialMultiplier: function() {
      let baseWidth = (this.psd) ? (this.json.objects[0].width) : 1080;
      let multiplier = baseWidth / this.heightAndWidth.width;
      return multiplier;
    },
    finalMultiplier: function() {
      let baseWidth = 1080;
      let multiplier = baseWidth / this.heightAndWidth.width;
      return multiplier;
    },
    finalImageMultiplier: function() {
      let baseWidth = this.story ? 1080 : 1200;

      if (this.template && this.template.customEditorWidth) {
        baseWidth = this.template.customEditorWidth;
      }
      
      let multiplier = baseWidth / this.heightAndWidth.width;
      return multiplier;
    }
  },
  created() {
    service.getMe().then(
      response => {
        this.me = response;
      },
      () => {
        this.showError = true;
      }
    );
  },
  mounted() {
    if (this.$route.query.customColorsCarousel && this.$route.query.customColorsCarousel != "0") {
      this.customColorsCarousel = true;
    }

    if (this.$route.query.challenge) {
      this.challenge = this.$route.query.challenge;
    }

    if (this.$route.query.carouselEditionId) {
      this.carouselEditionId = this.$route.query.carouselEditionId;
    } else {
       this.carouselEditionId = Math.random().toString();
    }

    if (this.$route.query.selectedColorId && this.$route.query.customColorsCarousel != "0") {
      this.selectedColorId = this.$route.query.selectedColorId;
    }

    if (this.$route.query.selectedCarouselLine) {
      this.selectedCarouselLine = this.$route.query.selectedCarouselLine
    }

    this.getColors().then(() => {
      this.reload();
    });
  },
  methods: {
    finishedLoadingAny() {
      this.loaded = true;
    },
    finishedDownload() {
      this.shouldDownload--;
      if (this.shouldDownload == 0) {
        this.downloading = false;
      }
    },
    goToChallenge() {
      this.$router.push({name: "Challenge", params: {id: this.challenge}});
    },
    saveAll() {
      this.listToDownload = [];

      for (let key in this.$refs.carouselItem) {
        this.listToDownload.push(this.$refs.carouselItem[key].getCreditUseId());
      }

      this.recursiveUseCredits(this.listToDownload);


      service.carouselSaveTemplate(this.templateId, this.carouselEditionId, this.customColorsCarousel, this.selectedColorId, this.selectedCarouselLine).then(() => {
        this.$router.push("/design/mine/");
      });
    },
    recursiveUseCredits(listToDownload, index) {
      if (this.alreadyUsedCredits || this.isMine) {
        return;
      }
      
      if (!index) {
        index = 0;
      }

      let vm = this;

      if (listToDownload && listToDownload[index]) {
        service.useCredits(listToDownload[index]).then(
          response => {
              vm.recursiveUseCredits(listToDownload, index + 1);
        }).catch(error => console.error(error));
      } else {
        var event = new CustomEvent("update-me", {});
        document.dispatchEvent(event);
        this.alreadyUsedCredits = true;
      }
    },
    downloadAll() {
      this.shouldDownload = 0;
      this.listToDownload = [];
      this.downloading = true;

      for (let key in this.$refs.carouselItem) {
        this.$refs.carouselItem[key].externalDownload();
        this.shouldDownload++;
        this.listToDownload.push(this.$refs.carouselItem[key].getCreditUseId());
      }

      this.recursiveUseCredits(this.listToDownload);

      /*for (let key in this.allCarouselTemplates) {
        var event = new CustomEvent("download" + this.allCarouselTemplates[key]._id, {});

        // Dispatch/Trigger/Fire the event
        document.dispatchEvent(event);

        if (this.allCarouselTemplates[key].customColorsVersion) {
          console.log("criando " + this.allCarouselTemplates[key].customColorsVersion._id);
          event = new CustomEvent("download" + this.allCarouselTemplates[key].customColorsVersion._id, {});

          // Dispatch/Trigger/Fire the event
          document.dispatchEvent(event);
        }
      }*/
    },
    updateCarousel() {
      this.reload();
    },
    refreshCarousel() {
      this.choosingAnotherColor = false;
      this.loaded = false;
      let vm = this;

      setTimeout(function() {
        vm.loaded = true;
      }, 2000);
    },
    enableColorChange() {
      this.customColorsCarousel = true;
      this.changingColor = true;
      this.choosingAnotherColor = true;
      //this.refreshCarousel();
    },
    disableColorChange() {
      this.customColorsCarousel = false;
      this.changingColor = false;
      this.filters = { hueValue: 0, saturationValue: 0, brightnessValue: 0};

      this.refreshCarousel();
    },
    colorChosen() {
      this.changingColor = false;

      this.refreshCarousel();

    },
    changeColor(filters, preventRefresh) {
      this.selectedColorId = 0;

      if (filters.id) {
        this.selectedColorId = filters.id;
      }

      this.lastHue = filters.hueValue;
      this.lastSaturation = filters.saturationValue;
      this.lastBrightness = filters.brightnessValue;
      this.filters = filters;

      if (filters.id) {
        this.lastColor = filters.id;
      }

      if (!preventRefresh) {
        this.refreshCarousel();
      }
    },
    async getColors() {
      return service.getColors().then((result) => {
        

        if (result.favoriteColors && result.favoriteColors.length) {
          this.favoriteColors = [];

          for (let key in result.colors) {
            if (result.favoriteColors.indexOf(result.colors[key]._id) >= 0) {
              this.favoriteColors.push(result.colors[key]);
            }

            if (this.selectedColorId && this.selectedColorId == result.colors[key]._id) {
              let selectedColor = result.colors[key];
              this.changeColor({ id: selectedColor._id, hueValue: selectedColor.hue ? selectedColor.hue : 0, saturationValue: selectedColor.saturation ? selectedColor.saturation : 0, brightnessValue: selectedColor.brightness ? selectedColor.brightness : 0 });
            }
          }
        }

        this.colors = result.colors;
      });
    },
    seeVersion(version) {
      this.selectedCarouselLine = version;
      this.customColorsCarousel = false;

      let total = 0;
      
      for (let key in this.allCarouselTemplates) {
        if (this.allCarouselTemplates[key] == this.selectedCarouselLine) {
          total++;
        }
      }

      this.creditsToDownloadAll = total;
    },
    downloadItem(url) {
      axios
        .get(url, { responseType: "blob" })
        .then(({ data }) => {
          const blob = new Blob([data], { type: "image/png" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = localStorage.whitelabelName + ".png";
          link.click();
        })
        .catch(error => console.error(error));
    },
    goToEditor() {
      if (this.$route.query.firstEdition) {
        //?firstEdition1
      }
    },
    expressEdition: function(input) {
      let chosenId = undefined;
      
      if (input && input.id) {
        chosenId = input.id;
      }

      //if (this.me.emailConfirmationTime || this.me.subscription.status != 2) {
        //service.useTemplate(this.template._id).then(
          //response => {
            let params = { firstEdition: false, shouldAllow: true, id: chosenId }

            params.filters = this.filters;
            
            params.customSavingUrl = "/design/preview-carousel/" + this.templateId + "/?customColorsCarousel=" + (this.customColorsCarousel ? 1 : 0) + "&selectedColorId=" + this.selectedColorId + "&selectedCarouselLine=" + this.selectedCarouselLine + "&carouselEditionId=" + this.carouselEditionId + "&challenge=" + this.challenge + "&ul=";
            
            params.carouselEditionId = this.carouselEditionId;

            if (this.lastColor) {
              service.registerColorUse(this.lastColor);
            }

            this.$router.push({ name: 'Editor', params: params });
            
            // Create the event
            //var event = new CustomEvent("update-me", {});

            // Dispatch/Trigger/Fire the event
            //document.dispatchEvent(event);
          //},
          //() => {
            //this.showError = true;
          //}
        //);
      /*} else {
        this.forbiddenEdition = true;
      }*/
    },
    reload() {
      this.loaded = false;
      service.getCarouselTemplateById(this.templateId, this.carouselEditionId).then(
        response => {
          this.allCarouselTemplates = response.allCarouselTemplates;
          
          if (!this.selectedCarouselLine) {
            this.selectedCarouselLine = this.allCarouselTemplates[0].carouselLine;
          }

          let total = 0;
      
          for (let key in this.allCarouselTemplates) {
            if (this.allCarouselTemplates[key].carouselLine == this.selectedCarouselLine) {
              total++;
            }
          }

          this.creditsToDownloadAll = total;

          for (let key in this.allCarouselTemplates) {
            if (!this.carouselLines[this.allCarouselTemplates[key].carouselLine]) {
              this.carouselLines[this.allCarouselTemplates[key].carouselLine] = {
                id: this.allCarouselTemplates[key].carouselLine,
                templates: []
              };

              this.carouselLinesList.push(this.allCarouselTemplates[key].carouselLine);
            }

            this.carouselLines[this.allCarouselTemplates[key].carouselLine].templates.push(this.allCarouselTemplates[key]);
          }

          if (!this.changingColor) {
            this.loaded = true;
          }
        },
        () => {
          //this.loaded = true;
          this.loadingJson = false;
        }
      );
    },
    calculateHeightAndWidth() {
      let baseHeight = (this.isMobileScreen) ? 250 : 360;
      let baseWidth = (this.isMobileScreen) ? 250 : 360;

      if (this.story) {
        baseHeight = (this.isMobileScreen) ? 250 : 480;
        baseWidth = (this.isMobileScreen) ? 140 : 270;
      }

      if (this.template && this.template.customEditorHeight && this.template.customEditorWidth) {
        let heightFactor = this.template.customEditorHeight / baseHeight;
        let widthFactor = this.template.customEditorWidth / baseWidth;
        let finalFactor = (widthFactor > heightFactor) ? widthFactor : heightFactor;
        let height = this.template.customEditorHeight / finalFactor;
        let width = this.template.customEditorWidth / finalFactor;
        
        this.heightAndWidth = { height: height, width: width };
      } else {
        this.heightAndWidth = { height: baseHeight, width: baseWidth };
      }
    },
    unlockAll() {
      this.preventLocking = true;
      if (this.actionList) {
        this.loadJSON(this.actionList, true, () => {});
      }
    },
    setBackgroundImage(backgroundImage) {
      //this.loadingJson = true;
      if (!this.$refs.canvas[0]) {
        setTimeout(() => {
          this.setBackgroundImage(backgroundImage);
        }, 100);
        return;
      }

      this.backgroundImage = backgroundImage;
      //this.loadingJson = false;
    },
    resetControls() {
      this.loadJSON(this.$refs.canvas[0].toJson(), true);
    },
    changeTextColor() {
      let copyItem = JSON.parse(JSON.stringify(this.$refs.canvas[0].toJson())); //deepCopy
      this.lastJson.push(copyItem);

      this.updatingTextProperties = true;
      this.changingTextColor = false;
      this.currentItem.fill = this.selectedColor.hex;
      if (this.currentItem && this.currentItem.styles) {
        for (let style in this.currentItem.styles) {
          for (let styleItem in this.currentItem.styles[style]) {
            this.currentItem.styles[style][styleItem].fill = this.selectedColor;
          }
        }
      }
      this.loadJSON(this.$refs.canvas[0].toJson(), null, () => {
        this.updatingTextProperties = false;
      });
    },
    changeTextFont(font) {
      let copyItem = JSON.parse(JSON.stringify(this.$refs.canvas[0].toJson())); //deepCopy
      this.lastJson.push(copyItem);

      this.updatingTextProperties = true;
      this.changingTextFont = false;
      this.currentItem.fontFamily = font;
      if (this.currentItem && this.currentItem.styles) {
        for (let style in this.currentItem.styles) {
          for (let styleItem in this.currentItem.styles[style]) {
            this.currentItem.styles[style][styleItem].fontFamily = font;
          }
        }
      }
      this.loadJSON(this.$refs.canvas[0].toJson(), null, () => {
        this.updatingTextProperties = false;
      });
    }
  }
};
</script>
